<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="oauth-client-manager-tab">
    <div>
        <span jhiTranslate="site-admin.oauth-clients.pane.title"></span>
        <span jhiTranslate="site-admin.oauth-clients.pane.comment"></span>
    </div>
    <br/>
    <div class="row pb-3">
        <div class="col d-flex justify-content-end">
            <button class="btn btn-outline-info" (click)="addOAuthClient()"><i class="fa fa-asterisk fa-md" aria-hidden="true"></i><span style="margin-left: 5px;" jhiTranslate="site-admin.oauth-clients.pane.add.oauth.client"></span></button>
        </div>
    </div>
    @if (oauthClients) {
        <div class="table-responsive">
            @if (oauthClients.length) {
                <table class="table table-striped table-bordered table-curved">
                    <thead>
                    <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
                        <th [jhiSortBy]="ColumnLabels.ID"><span jhiTranslate="site-admin.oauth-clients.pane.table.column.id">ID</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnLabels.CLIENT_ID"><span jhiTranslate="site-admin.oauth-clients.pane.table.column.client.name">Client ID</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnLabels.REDIRECT_URI"><span jhiTranslate="site-admin.oauth-clients.pane.table.column.redirect.uri">Redirect URI</span> <span class="fa fa-sort"></span></th>
                        <th [jhiSortBy]="ColumnLabels.DESCRIPTION"><span jhiTranslate="site-admin.oauth-clients.pane.table.column.description">Description</span> <span class="fa fa-sort"></span></th>
                        <th><span jhiTranslate="site-admin.oauth-clients.pane.table.column.action">Action</span></th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (oauthClient of oauthClients; track oauthClient.id; let index = $index) {
                            <tr>
                                <td> {{oauthClient.id}} </td>
                                <td><a href="javascript:void(0)" (click)="editOAuthClient(oauthClient)">{{oauthClient.clientId}}</a></td>
                                <td>{{oauthClient.redirectUri}}</td>
                                <td>{{oauthClient.description}}</td>
                                <td class="fit">
                                    <button class="btn btn-outline-info btn-sm me-2" (click)="editOAuthClient(oauthClient)">
                                        <i class="fa fa-edit fa-md" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-info btn-sm me-2" (click)="deleteOAuthClient(oauthClient)">
                                        <i class="fa fa-trash fa-md" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            } @else {
                <table class="table table-striped table-bordered table-curved">
                    <thead>
                    <tr>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td jhiTranslate="no.data"></td>
                    </tr>
                    </tbody>
                </table>
            }
        </div>
    }
    @if (oauthClients && oauthClients.length) {
        <div>
            <div class="row">
                <div class="col">
                    <div class="pagination-container">
                        <div class="pagination-box pagination-box-left">
                            <div>
                                <jhi-item-count [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count>
                            </div>
                        </div>
                        <div class="pagination-box">
                            <ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
                                            [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
                        </div>
                        <div class="pagination-box pagination-box-right">
                            <div class="d-flex align-items-center">
                                <label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
                                <select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="loadAll();" style="width:95px">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="75">75</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    <div class="row pb-4">
        <span><h2><span jhiTranslate="site-admin.oauth-clients.bms.instance.details.title">BMS OAuth Details</span></h2></span>
        <span jhiTranslate="site-admin.oauth-clients.bms.instance.details.description"></span>
    </div>

    @if (oauthConfig) {
        <div class="row pb-3">
            <div class="col">
                <div class="row mb-2">
                    <label class="col-sm-1 col-form-label fw-bold" jhiTranslate="site-admin.oauth-clients.pane.table.column.client.name"></label>
                    <div class="col-sm-6 value-chip-light">
                        <truncate-span [maxLength]="100" [textInput]="oauthConfig.clientId"></truncate-span>
                    </div>
                </div>
                <div class="row mb-2">
                    <span class="col-sm-1 col-form-label fw-bold" jhiTranslate="site-admin.oauth-clients.pane.table.column.redirect.uri"></span>
                    <div class="col-sm-6 value-chip-light">
                        <truncate-span [maxLength]="1024" [textInput]="oauthConfig.redirectUri"></truncate-span>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
